import { useEffect, useState } from "react";
import { useDialog } from "@shared/features/dialog/useDialog";
import { useFieldProps } from "@shared/features/form/useFieldProps";
import { Dialog } from "@shared/ui/Dialog";
import { Article, Category, SupportSearchResults } from "../../support.types";
import packSupportSearchResults from "../../utils/packSupportSearchResults";
import SupportSearchFormResults from "./SupportSearchFormResults";

export type Props = {
  articles: Article[];
  categories: Category[];
  onArticleResultClick: (article: Article) => void;
};

export function SupportSearchForm({
  articles,
  categories,
  onArticleResultClick,
}: Props) {
  const { activeDialog, closeDialog } = useDialog();

  const [searchQuery, setSearchQuery] = useState("");

  const [results, setResults] = useState<SupportSearchResults>({});

  const isOpen = activeDialog === "supportSearch";

  const fieldProps = useFieldProps({});

  useEffect(() => {
    if (!searchQuery.trim()) {
      setResults({});
      return;
    }

    const query = searchQuery.toLowerCase();

    const matchedArticles = articles.filter(
      (article) =>
        article.title.toLowerCase().includes(query) ||
        article.excerpt?.toLowerCase().includes(query)
    );

    // Group results by category
    const groupedResults = packSupportSearchResults(
      matchedArticles,
      categories
    );

    setResults(groupedResults);
  }, [searchQuery, articles, categories]);

  return (
    <Dialog
      title="Search Support"
      description="Search through our help articles and FAQs."
      isOpen={isOpen}
      onClose={() => closeDialog("supportSearch")}
      isWithActions={false}
      primaryButtonText="Search"
      secondaryButtonText="Cancel"
      onPrimaryClick={() => {}}
      onSecondaryClick={() => {}}
    >
      <div className="flex flex-col pt-4 pb-8">
        <input
          name="search"
          type="text"
          placeholder="Search Pollinator Support"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          {...fieldProps}
        />
      </div>

      <SupportSearchFormResults
        query={searchQuery}
        results={results}
        onArticleResultClick={onArticleResultClick}
      />
    </Dialog>
  );
}

export default SupportSearchForm;
